import './App.css';
import './utils/global'
import {useEffect, useState} from "react";
import Main from "./pages/main";
import Login from "./pages/login";
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  const [user, setUser] = useState({});

  const getUserData = async () => {
    let token = await window.getData("loginToken");
    console.log(token);
    if(!token || token==='') {
      setUser(null);
      return;
    }
    window.reqServer("/user/login/token", "get", {token, notificationToken: null}, (user)=>{
      if(!user?.error)
        setUser(user);
      else
        setUser(null);
    })
  }

  console.log(user);

  useEffect(() => {
    getUserData();
  }, [])

  return <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    {user?.tier === 3 ? <Main user={user} setUser={setUser} /> : <Login setUser={setUser} />}
  </GoogleOAuthProvider>
}

export default App;
